import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components/macro';
import { SVG } from 'components';
import { Icons } from 'assets';

export const Separator: FC = observer(() => {
  const theme = useTheme();

  return (
    <div>
      <SVG
        src={Icons.Chevron}
        props={{ color: theme.colors.gray[500], deg: -90 }}
      />
    </div>
  );
});
